export default "__VITE_ASSET__B4D04uPq__"